import React from 'react';
import AdicionarDocumentoDialog from '../../../components/documentos/AdicionarDocumentoDialog';

export default function AdicionarContratoEnderecoFiscal(props) {
    return (
        <AdicionarDocumentoDialog
            open={props.adicionarContrato}
            onClose={() => props.setAdicionarContrato(false)}
            endpoint="adicionarContratoEnderecoFiscal"
            title="Nova versão do Contrato de Endereço Fiscal"
            description="O conteúdo publicado passa a valer como a versão mais recente do contrato."
            placeholder="Digite o contrato de endereço fiscal aqui..."
        />
    );
}
